import { atom } from 'jotai/vanilla';
import type { ViewCollectionContents } from '@view-model/domain/view/ViewCollectionContents';
import type { ViewModelId } from 'balus-common';

type AtomValue = {
  viewContentsRecord: Record<ViewModelId, ViewCollectionContents | undefined>;
};

export const viewModelPageContentAtom = atom<AtomValue>({
  viewContentsRecord: {},
});
